import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewbox="0 0 16 17" viewBox="0 0 16 17" fill="none"><path d="M13.2975 4.12932C13.4957 2.86473 13.2964 2.00436 12.6122 1.22527C11.8594 0.367528 10.4993 0 8.75922 0H3.70768C3.35221 0 3.04917 0.259 2.99359 0.610275L0.890136 13.9482C0.848717 14.212 1.05214 14.4495 1.31848 14.4495H4.43696L4.22148 15.8147C4.18531 16.0449 4.36356 16.253 4.59687 16.253H7.22567C7.53657 16.253 7.80134 16.0265 7.8501 15.7193L7.87579 15.5856L8.37072 12.4456L8.4027 12.2721C8.45146 11.9648 8.71623 11.7378 9.02713 11.7378H9.42035C11.9668 11.7378 13.9607 10.7039 14.5432 7.71127C14.787 6.46136 14.6612 5.4175 14.0173 4.68402C13.8223 4.46276 13.5801 4.27926 13.2975 4.12932Z" fill="#009CDE"></path><path d="M13.2975 4.12932C13.4957 2.86473 13.2964 2.00436 12.6122 1.22527C11.8594 0.367528 10.4993 0 8.75922 0H3.70768C3.35221 0 3.04917 0.259 2.99359 0.610275L0.890136 13.9482C0.848717 14.212 1.05214 14.4495 1.31848 14.4495H4.43697L5.22026 9.4818L5.19614 9.63804C5.25171 9.28624 5.55161 9.02777 5.9076 9.02777H7.38977C10.3006 9.02777 12.5797 7.84497 13.2461 4.42502C13.2655 4.32383 13.2823 4.22631 13.2975 4.12932Z" fill="#012169"></path><path d="M6.06227 4.14609C6.0953 3.9348 6.23109 3.76179 6.41354 3.67423C6.49638 3.63439 6.58918 3.61237 6.6867 3.61237H10.6467C11.1159 3.61237 11.5532 3.6433 11.9532 3.70779C12.0675 3.72614 12.1786 3.74711 12.2867 3.77123C12.3947 3.79482 12.4995 3.82156 12.6012 3.85144C12.6521 3.86612 12.7019 3.88185 12.7512 3.8981C12.9478 3.96364 13.1308 4.04019 13.2985 4.12932C13.4967 2.86473 13.2975 2.00436 12.6133 1.22527C11.8594 0.367528 10.4993 0 8.75922 0H3.70768C3.35221 0 3.04917 0.259 2.99359 0.610275L0.890136 13.9482C0.848717 14.212 1.05214 14.4495 1.31848 14.4495H4.43697L5.22026 9.4818L6.06227 4.14609Z" fill="#003087"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
